// Enquiry client for POST /api/enquiries.
//
// Success is returned only when the API body has ok: true and a referenceId.
// Until a CRM is configured, the API returns a recoverable error and this
// client does not invent a reference. CRM credentials never belong in this file.

const TIMEOUT_MS = 15000;

export class EnquiryError extends Error {
  constructor(code, errors) {
    super(code);
    this.name = "EnquiryError";
    this.code = code;
    this.errors = errors || null;
  }
}

export async function submitEnquiry(payload) {
  const base = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), TIMEOUT_MS);
  try {
    const response = await fetch(`${base}/api/enquiries`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        ...payload,
        campaign: payload.campaign || null,
      }),
      signal: controller.signal,
    });
    let body = {};
    try {
      body = await response.json();
    } catch {
      body = {};
    }
    if (response.status === 422) {
      throw new EnquiryError("VALIDATION", body.errors || {});
    }
    if (!response.ok || body.ok !== true || !body.referenceId) {
      throw new EnquiryError(body.error || "SERVER_ERROR");
    }
    return {
      ok: true,
      referenceId: body.referenceId,
      duplicate: Boolean(body.duplicate),
    };
  } catch (err) {
    if (err instanceof EnquiryError) throw err;
    if (err && err.name === "AbortError") throw new EnquiryError("TIMEOUT");
    throw new EnquiryError("SERVER_ERROR");
  } finally {
    clearTimeout(timer);
  }
}

export const submitDemoRequest = submitEnquiry;
